import Keycloak, { KeycloakConfig } from 'keycloak-js';

class KeycloakStore {
  private static keycloakStore: KeycloakStore = new KeycloakStore();

  private keycloakInstance: Keycloak | undefined;

  public init(config: KeycloakConfig) {
    this.keycloakInstance = new Keycloak(config);
  }

  public getKeycloakInstance(): Keycloak | undefined {
    return this.keycloakInstance;
  }

  public static getInstance() {
    return this.keycloakStore;
  }
}

export default KeycloakStore.getInstance();
